import React from 'react';
import cx from 'classnames';
import { DownIcon } from '@trello/nachos/icons/down';
import { AddIcon } from '@trello/nachos/icons/add';
import styles from './CellWrapper.less';
import { TableTestClasses } from '@trello/test-ids';

interface CellWrapperProps extends React.HTMLAttributes<HTMLDivElement> {
  clickable?: boolean;

  /** Only applies if clickable is true. */
  hideIcon?: boolean;
  isEmpty?: boolean;
  clickableIcon?: typeof DownIcon;
  hovered?: boolean;
  testClass?: TableTestClasses;
}

export const CellWrapper = React.forwardRef<HTMLDivElement, CellWrapperProps>(
  (
    {
      children,
      className,
      clickable,
      hideIcon,
      isEmpty,
      clickableIcon,
      hovered,
      testClass,
      ...props
    },
    ref,
  ) => {
    const ClickableIcon = clickableIcon || DownIcon;

    return (
      <div
        {...props}
        ref={ref}
        className={cx(styles.cellWrapper, className, {
          [styles.clickable]: clickable,
          [styles.hovered]: hovered,
        })}
        data-test-class={testClass}
      >
        {children}

        <div className={styles.gradientOverlay}></div>
        <div className={styles.dividerOverlay}>
          {clickable && !hideIcon && !isEmpty && (
            <span className={styles.chevron}>
              <ClickableIcon size={'small'} />
            </span>
          )}
        </div>
        {isEmpty && (
          <div className={styles.emptyOverlay}>
            <div className={styles.emptyDot} />
            {clickable && !hideIcon && (
              <span className={styles.addIcon}>
                <AddIcon size={'small'} />
              </span>
            )}
          </div>
        )}
      </div>
    );
  },
);
